import React from 'react';

import { QueryMode } from 'src/api';
import { useFilterStorage, useSearchQueryVariables } from 'src/hooks/common';
import { useIntegrations } from 'src/hooks/integration';
import { prepareIntegrationsFilter } from 'src/utils/integrations';

import { InboundIntegrationsTable } from './InboundIntegrationsTable';

export const InboundIntegrationsPageWrapper: React.FC = () => {
  const searchQueryVariables = useSearchQueryVariables<{
    name?: { contains: string; mode: QueryMode };
  }>(searchValue =>
    searchValue ? { name: { contains: searchValue, mode: QueryMode.Insensitive } } : {},
  );

  const { filter, sortQueryVariable, paginationQueryVariables, pagination } = useFilterStorage();
  const filterQueryVariables = prepareIntegrationsFilter(filter);

  const { integrationsList, integrationsCount, integrationsLoading, refetch } = useIntegrations(
    {
      ...searchQueryVariables,
      ...filterQueryVariables,
    },
    sortQueryVariable,
    paginationQueryVariables,
    true,
  );

  const refetchData = React.useCallback(async () => {
    await refetch();
    pagination.resetPage();
  }, [pagination, refetch]);

  return (
    <InboundIntegrationsTable
      integrationsList={integrationsList}
      integrationsCount={integrationsCount}
      onRefresh={refetchData}
      pagination={pagination}
      loading={integrationsLoading}
    />
  );
};
